import { apiClient } from './client';
import { PaginatedResponse } from '../types/pagination';
import { CallLog, CommDirection } from '../types/communications';

export const listCalls = async (leadId: number): Promise<PaginatedResponse<CallLog>> => {
  const { data } = await apiClient.get('/calls', { params: { leadId, pageSize: 100 } });
  return data;
};

export interface LogCallPayload {
  leadId: number;
  direction: CommDirection;
  phoneNumber: string;
  durationSeconds?: number;
  disposition?: string;
  notes?: string;
  recordingUrl?: string;
}

export const logCall = async (payload: LogCallPayload): Promise<CallLog> => {
  const { data } = await apiClient.post('/calls', payload);
  return data.data;
};
